
import { reactive, computed } from 'vue';
import { useI18n } from 'vue-i18n';
export default {
  components: {},
  props: {
    placeholder: {  // placeholder
      type: Object,
      default() {
        return {
          text: 'Select Please',
          val: 'default',
        }
      }
    },
    options: {
      type: Array,
      default() {
        return [{
          text: '1-001',
          val: '001',
        },
        {
          text: '1-002',
          val: '002',
          sub: [{
            text: '2-00001',
            val: '00201'
          },
          {
            text: '2-00001',
            val: '00202'
          }]
        },
        ]
      }
    },
    selected: {   //被選擇的值
      type: Object,
      default() {
        return {
          text: 'Select Please',
          val: 'default',
        }
      }
    }, //end: selected
    isError: {
      type: Boolean,
      default: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    h: {
      type: String,
      default: 'default', // xl -> 56px
    },
    error: {
      type: String,
      default: '',
      require: false,
    },
    isShowErrorTxt: {   //當有錯誤時是否顯示錯誤文字
      type: Boolean,
      default: true,
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const { selected, isDisable } = props;
    //data
    let state = reactive({
      isOpen: false,
      errorStyle: '',
      disableStyle: isDisable ? 'style--disable' : '',
    })
    //computed
    const classStyle = computed(() => {
      return [
        { 'active': state.isOpen },
        { 'style--error': props.isError },
        { 'style--error': props.error },
        { 'style--disable': props.isDisable },
        'style--' + props.h,
      ]
    })
    let privateSelected = computed({
      get: () => selected,
      set: (val) => {
        // console.log(val)
        emit('update:selected', val);
      }
    })

    // watch(
    //   () => props.isError,
    //   (val) => {
    //     state.errorStyle = val ? 'style--error' : '';
    //   })

    // watch(
    //   () => props.isDisable,
    //   (val) => {
    //     state.disableStyle = val ? 'style--disable' : '';
    //   })


    //change selected option, methods
    const onChange = (item) => {
      state.isOpen = !state.isOpen;
      const selected = { ...item }
      privateSelected.value = selected;
      emit('onChange', selected);
    }
    // click the select box
    const onClick = () => {
      state.isOpen = !state.isOpen;
    }
    const handleFocusOut = () => {
      state.isOpen = false
    }

    return {
      state,
      onClick,
      onChange,
      handleFocusOut,
      classStyle,
      privateSelected,
      t
    }
  }


}


